export enum MatchAtsSyncStatusEnum {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Finished = 'FINISHED',
  Failed = 'FAILED',
}
